module.exports = __webpack_public_path__ + "static/media/detail.be69f198.svg";